import React from 'react';
import { useCurrentEditor } from '@tiptap/react';
import { safelyParseInt } from '@/utils/constants';
import { HEADINGS } from './data';
import ToolbarDropdown from '@/components/TiptapEditor/Toolbar/Dropdowns/ToolbarDropdown';

const headings = [{ label: 'Normal', value: '', type: 'header', default: '' }].concat(
	...HEADINGS.map((header, index) => ({
		label: header,
		value: index + 1,
		type: 'header',
		default: '',
	}))
);

const ToolbarHeadingSelect = () => {
	const { editor } = useCurrentEditor();

	const activeHeading = (() => {
		for (let i = 1; i <= HEADINGS.length; i++) {
			if (editor?.isActive('heading', { level: i })) return i;
		}
	})();

	return (
		<ToolbarDropdown
			title='Heading'
			showSelection={true}
			defaultValue={activeHeading}
			fields={headings}
			onChange={(e) => {
				const level = safelyParseInt(e.target.value);

				if (level === 0) {
					editor.chain().focus().setParagraph().run();
				} else {
					editor.chain().focus().toggleHeading({ level }).run();
				}
			}}
			sx={{
				width: '110px',
			}}
		/>
	);
};

export default ToolbarHeadingSelect;
